import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const EducationDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Education Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
        <div className="table-responsive">
          <table className="table table-responsive">
            <thead>
              <tr>
                <th>Degree Name</th>
                <th>Field Of Study</th>
                <th>Institution Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Grade</th>
                <th>Country</th>
                {/* <th>Document Image</th> */}
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {employee?.educationalQualificationList?.map((education) => (
                <tr key={education.qualificationID}>
                  <td>{education.degreeName}</td>
                  <td>{education.fieldOfStudy}</td>
                  <td>{education.institutionName}</td>
                  <td>{education.startDate && format(new Date(education.startDate), "yyyy-MM-dd")}</td>
                  <td>{education.endDate && format(new Date(education.endDate), "yyyy-MM-dd")}</td>
                  <td>{education.grade}</td>
                  <td>{education.country}</td>
                  {/* <td>
                    {education?.documentImage !== "" ? (
                      <img
                        src={education?.documentImage}
                        alt="Pass Front Image"
                        width={60}
                      />
                    ) : (
                      ""
                    )}
                  </td> */}
                  <td>{education.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  );
};

EducationDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default EducationDetails;
